import React from "react";

const InventoryValue = ({title}) => {
  return (
    <div className="bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36">
      <h2 className="font-bold md:ml-36">Inventory {title}</h2>
      <div className="flex flex-col items-center justify-center  gap-y-20">
        <div>
          <p className="font-extrabold text-2xl">$0.00</p>
          <p className="font-extrabold text-md">($0.00)</p>
          <p className="font-extrabold text-md">Last Day</p>
        </div>
        <button className="shadow-sm rounded-lg py-2 px-1 shadow-black">
          No Data Available
        </button>
        <hr className="border-2 border-pinkColor w-full -mb-16" />
        <div className="flex justify-center items-between gap-x-2">
          <button
            type="button"
            className="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-extrabold rounded-lg text-sm text-center mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase px-1 py-1.5 flex items-center justify-center"
          >
            1M
          </button>
          <button
            type="button"
            className="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-extrabold rounded-lg text-sm text-center mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase px-1 py-1.5 flex items-center justify-center"
          >
            3M
          </button>
          <button
            type="button"
            className="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-extrabold rounded-lg text-sm text-center mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase px-1 py-1.5 flex items-center justify-center"
          >
            6M
          </button>
          <button
            type="button"
            className="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-extrabold rounded-lg text-sm text-center mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase px-1 py-1.5 flex items-center justify-center"
          >
            12M
          </button>
          <button
          type="button"
          className="focus:outline-none text-white bg-pinkColor hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-lg text-sm uppercase font-semibold px-1 py-1.5 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 w-full  flex items-center justify-center"
        >
          max
        </button>
        </div>
      </div>
    </div>
  );
};

export default InventoryValue;
